import { RemoveMargins, Scale } from "@pdfking/math"
import { ZERO_DISTANCE } from "@pdfking/math/constants"
import { MM } from "@pdfking/quantity"

import type { CalendarBoxes, PageContext } from "#internal"

import { PageMetrics } from "../layout/PageMetrics"
import { Slice } from "../layout/Slice"

// The gap between areas, and the contact's height on the page's short side
const GAP = MM(5)
const CONTACT = 0.08

/** Where a calendar's page lays its areas (see CalendarBoxes): its body over
 * the contact when it has a `footer`, down to the frame's foot when not. */
export const CalendarFrame = (context: PageContext, footer: boolean): CalendarBoxes => {
  const { security, size } = context
  const page = { ...size, x: ZERO_DISTANCE, y: ZERO_DISTANCE }
  const outer = RemoveMargins(page, security)
  const { short } = PageMetrics(size)
  const [contact, body] = Slice.bottom(outer, Scale(short, CONTACT), GAP)
  return { ...context, body: footer ? body : outer, contact, gap: GAP, outer, page, short }
}
